import type { ReactNode } from "react";

export function MeterRow({ aside, children }: { aside?: string; children: ReactNode }) {
  return (
    <div className="flex items-center gap-3">
      <div className="min-w-0 flex-1">{children}</div>
      {aside && <span className="shrink-0 text-sm text-muted-foreground tabular-nums">{aside}</span>}
    </div>
  );
}
